import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, Cell } from 'recharts';

class PersoneticsHorizontalBarChart extends Component {

    render() {
        const { dataObject } = this.props;
        let reversedData;
        let barChartData;
        if(dataObject.size>0){
            const categories = dataObject.get('categories');
            const series = dataObject.get('series').map(data => {
                let seriesObject = data.map(i => {
                    return i.get('value');
                });
                return seriesObject
            });
            barChartData = categories.map((x, i) => {
                return { "name": x, "in": series.getIn([`${i}`, 0]), "out": series.getIn([`${i}`, 1]) }
            });
            reversedData = barChartData.toJS().reverse();
        }

        return (
            <BarChart
                width={400}
                height={150}
                data={reversedData}
                barGap={3}
            >
                <XAxis type="category" dataKey="name" tickLine={false} axisLine={false} />
                <YAxis type="number" tick={false} axisLine={false} />
                <Bar background dataKey="in" fill="#fbb800" barSize={15}>
                    {
                        barChartData.map((entry, index) => (
                            <Cell opacity={index == (barChartData.size - 1) ? '0.8' : '0.4'} />
                        ))
                    }
                </Bar>
                <Bar background dataKey="out" fill="#16aa8b" barSize={15}>
                    {
                        barChartData.map((entry, index) => (
                            <Cell opacity={index == (barChartData.size - 1) ? '0.8' : '0.4'} />
                        ))
                    }
                </Bar>
            </BarChart>
        );
    }
}

PersoneticsHorizontalBarChart.propTypes = {
    animationBegin: PropTypes.number,
    axisLine: PropTypes.bool,
    bars: PropTypes.array.isRequired,
    dataObject: PropTypes.array.isRequired,
    fills: PropTypes.array,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    interval: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    lastFills: PropTypes.array,
    legend: PropTypes.bool,
    margin: PropTypes.object,
    referenceLineData: PropTypes.object,
    referenceLineStroke: PropTypes.string,
    tooltip: PropTypes.bool,
    tooltipContent: PropTypes.func,
    unit: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    xAxis: PropTypes.string.isRequired,
    xTickComponent: PropTypes.object
};

PersoneticsHorizontalBarChart.defaultProps = {
    fills: [],
    legend: false,
    tooltip: true
}

export default PersoneticsHorizontalBarChart;